import { SVGProps } from 'react'

export const NeWordSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g fill='none' fillRule='evenodd'>
      <path
        d='m14.438 1.5 6 6v12.75a2.25 2.25 0 0 1-2.25 2.25H5.813a2.25 2.25 0 0 1-2.25-2.25V3.75a2.25 2.25 0 0 1 2.25-2.25h8.625Zm1.601 7.62a.75.75 0 0 0-.92.528l-1.21 4.481-1.16-3.887-.055-.114-.054-.08-.058-.066-.082-.072-.083-.055-.092-.044-.051-.018-.09-.023-.098-.011-.109.002-.092.014-.052.014-.095.035a.745.745 0 0 0-.244.177l-.025.029-.038.05-.033.052-.053.111-1.161 3.886-1.21-4.48-.033-.097a.75.75 0 0 0-1.415.487l1.898 7.031.038.11c.265.62 1.2.595 1.405-.09l1.18-3.958 1.18 3.957.04.108c.282.613 1.216.565 1.402-.127l1.899-7.03.02-.1a.75.75 0 0 0-.549-.82Z'
        fill='#4E86E6'
      />
      <path d='M14.438 1.5V6a1.5 1.5 0 0 0 1.5 1.5h4.5l-6-6Z' fill='#A9C6F3' />
    </g>
  </svg>
)
